"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseJob = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_1 = require("./contact");
const customer_signature_reason_enum_1 = require("./customer-signature-reason-enum");
const customer_signature_status_enum_1 = require("./customer-signature-status-enum");
class BaseJob {
}
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hcu_idx_job__c_sfid'),
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('a1r')",
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Index)('hcu_idx_job__c_api_id__c'),
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'api_id__c',
        unique: true,
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "apiId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)('idx_trgm_job_aff_id', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'affiliate_id__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "affiliateId", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('idx_trgm_job_name', { synchronize: false }),
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'name',
        length: 80,
        unique: true,
        default: () => "gid_generate_name('O', 10)",
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'import_id__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "importId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        length: 18,
        name: 'customer__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "customerId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        length: 18,
        name: 'customer_second__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "customerSecondId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        length: 18,
        name: 'professional__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "partnerId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        length: 18,
        name: 'opportunity__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "opportunityId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 2,
        nullable: true,
        name: 'country__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "countryCode", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_job_eid', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'eid__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "eid", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_job_inv_eid', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'invoicing_eid__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "invoicingEid", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'project_id__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "projectId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'brand__c',
        length: 18,
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "brandId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'brand2__c',
        length: 18,
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "brand2Id", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('Job_Status'),
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: false,
        name: 'status__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "status", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)('idx_trgm_job_owner_id', { synchronize: false }),
    (0, typeorm_1.ManyToOne)(() => contact_1.Contact, { nullable: true }),
    (0, typeorm_1.JoinColumn)({
        name: 'owner__c',
    }),
    __metadata("design:type", contact_1.Contact)
], BaseJob.prototype, "ownerId", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "createdDate", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp', {
        nullable: true,
        name: 'date_start__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "dateStart", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp', {
        nullable: true,
        name: 'date_end__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "dateEnd", void 0);
__decorate([
    (0, typeorm_1.Column)('date', {
        nullable: true,
        name: 'readiness_date__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "readinessDate", void 0);
__decorate([
    (0, typeorm_1.Column)('date', {
        nullable: true,
        name: 'date_expected__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "dateExpected", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp', {
        nullable: true,
        name: 'appointment_customer_start__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "appointmentStart", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp', {
        nullable: true,
        name: 'appointment_customer_end__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "appointmentEnd", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_selling__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "priceSellingOverride", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_purchasing__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "pricePurchasingOverride", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'service_price_purchasing_sum',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "servicePricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'products_price_purchasing_sum',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "productsPricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_lists_override__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "priceListsOverride", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_selling_sum__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "priceSellingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_purchasing_sum__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "pricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_lists__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "priceListsSum", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'professional_comment__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "professionalComment", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: true,
        name: 'internal_comments__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "internalComments", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 128,
        nullable: true,
        name: 'referrer__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "referrer", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('bool', {
        nullable: true,
        name: 'test_order__c',
    }),
    __metadata("design:type", Boolean)
], BaseJob.prototype, "testOrder", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'picture_02__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "picture_02", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'picture_01__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "picture_01", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_selling_total__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "priceSellingTotal", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'result__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "result", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'result_type__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "resultType", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'price_purchasing_total__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "pricePurchasingTotal", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'isdeleted',
    }),
    __metadata("design:type", Boolean)
], BaseJob.prototype, "isDeleted", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp without time zone', {
        nullable: true,
        name: 'systemmodstamp',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "systemmodstamp", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 5,
        name: 'availability_customer_starts__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "availabilityCustomerStarts", void 0);
__decorate([
    (0, typeorm_1.Column)('date', {
        nullable: true,
        name: 'date__c',
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 1300,
        nullable: true,
        name: 'description_en__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "descriptionEn", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'quantity__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "quantity", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 1300,
        nullable: true,
        name: 'description_de__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "descriptionDe", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'protocol_upload__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "protocolUpload", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp without time zone', {
        nullable: true,
        name: 'timestamp_appointment_confirmed__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "timestampAppointmentConfirmed", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'sla_2__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "sla2", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'sla_1__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "sla1", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'aac__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "aac", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'initial_visibility__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "initialVisibility", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'tc_accepted_by_customer__c',
    }),
    __metadata("design:type", Boolean)
], BaseJob.prototype, "tcAcceptedByCustomer", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'job_source__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "jobSource", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
        name: 'superseded_by__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "supersededBy", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'superseded_by__r__api_id__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "supersededBy_r_apiId", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'aed__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "aed", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        default: false,
        nullable: true,
        name: 'invoiced_by_brand__c',
    }),
    __metadata("design:type", Boolean)
], BaseJob.prototype, "invoicedByBrand", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'revenue__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "revenue", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'cost__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "cost", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'total_paid',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "totalPaid", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'service_total_minutes__c',
    }),
    __metadata("design:type", Number)
], BaseJob.prototype, "serviceTotalMinutes", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 5,
        name: 'availability_customer_ends__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "availabilityCustomerEnds", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
        name: 'service__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "service", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Partner External Eid', emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        length: 64,
        nullable: true,
        name: 'partner_eid__c',
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "extPartnerId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: customer_signature_status_enum_1.CustomerSignatureStatusEnum,
        default: customer_signature_status_enum_1.CustomerSignatureStatusEnum.MISSING,
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "customerSignature", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: customer_signature_reason_enum_1.CustomerSignatureReasonEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseJob.prototype, "customerSignatureReason", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'proposal_date',
        type: 'timestamp with time zone',
        nullable: true,
    }),
    __metadata("design:type", Date)
], BaseJob.prototype, "proposalDate", void 0);
exports.BaseJob = BaseJob;
//# sourceMappingURL=base-job.js.map